import { ButtonProvider, FieldButton } from "@/component/common/button";
import { Header } from "@/component/common/header";
import { Spacing } from "@/component/common/Spacing";
import { purposeArr, purposeMap } from "@/component/retrospect/template/recommend/recommend.const";
import { useToast } from "@/hooks/useToast";
import { recommendTemplateState } from "@/store/retrospect/template/recommend/recommendAtom";
import { PurposeType, RecommendTemplateType } from "@/types/retrospectCreate/recommend";
import { css } from "@emotion/react";
import { useAtomValue } from "jotai";
import { useState } from "react";

interface PurposeProps {
  onNext: (purposeValue: Pick<RecommendTemplateType, "purpose">) => void;
  onPrev: () => void;
}

export function Purpose({ onNext, onPrev }: PurposeProps) {
  const { purpose } = useAtomValue(recommendTemplateState);
  const [selectedPurpose, setSeletedPurpose] = useState(purpose);
  const { toast } = useToast();

  const handleButtonClick = (select: PurposeType) => {
    if (selectedPurpose && selectedPurpose.includes(select)) {
      setSeletedPurpose(selectedPurpose.filter((pre) => pre !== select));
    } else {
      if (selectedPurpose && selectedPurpose.length <= 2) {
        setSeletedPurpose((pre) => [...pre, select]);
      } else {
        toast.error("최대 3개까지 선택 가능해요.");
      }
    }
  };

  return (
    <main
      css={css`
        display: flex;
        flex-direction: column;
        height: 100%;
      `}
    >
      <Header title={`회고를 하는\n목적이 무엇인가요?`} contents="최대 3개까지 선택가능해요" />
      <Spacing size={4} />
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          gap: 0.8rem;
        `}
      >
        {purposeArr.map((item) => (
          <FieldButton
            key={item}
            field={purposeMap[item]}
            onClick={() => handleButtonClick(item)}
            isChecked={selectedPurpose.includes(item)}
            size={1.8}
          />
        ))}
      </div>
      <ButtonProvider sort={"horizontal"}>
        <ButtonProvider.Gray onClick={onPrev}>이전</ButtonProvider.Gray>
        <ButtonProvider.Primary
          onClick={() =>
            onNext({
              purpose: selectedPurpose,
            })
          }
          disabled={selectedPurpose?.length === 0}
        >
          다음
        </ButtonProvider.Primary>
      </ButtonProvider>
    </main>
  );
}
